import { ErrorHandler, Injectable, inject } from '@angular/core';
import { createErrorHandler } from '@sentry/angular';
import { BehaviorSubject } from 'rxjs';
import { CustomError } from '@core/errors';
import { SnackbarService } from '../snackbar/snackbar.service';
import { ERROR_HANDLER_MAPPER } from './error-handler.provider';

@Injectable({
  providedIn: 'root',
})
export class ErrorHandlerService implements ErrorHandler {
  private sentryHandler = createErrorHandler();
  private snackbar = inject(SnackbarService);
  private mappers = inject(ERROR_HANDLER_MAPPER);

  private _lastError = new BehaviorSubject<string | undefined>(undefined);
  readonly lastError = this._lastError.asObservable();

  handleError(error: any) {
    if (error.promise && error.rejection) {
      error = error.rejection;
    }

    for (const mapper of this.mappers) {
      error = mapper.mapError(error);
    }
    if (!error) {
      return;
    }

    if (this.shouldReport(error)) {
      this.doReport(error);
    }

    if (this.shouldDisplay(error)) {
      const message = this.doDisplay(error);
      this.setLastError(message);
    } else {
      this.setLastError(undefined);
    }
  }
  private setLastError(message: string | undefined) {
    this._lastError.next(message);
  }

  private shouldReport(_error: any) {
    return true;
  }

  private shouldDisplay(_error: any) {
    return true;
  }

  private doReport(error: any) {
    this.sentryHandler.handleError(error);
  }

  private doDisplay(error: any) {
    console.error('handleError', error);
    let message: string = error.message;

    if (!(error instanceof CustomError)) {
      message = 'Unexpected error: ' + message;
    }

    error.isWarning
      ? this.snackbar.warning(message, null) // Keep open
      : this.snackbar.error(message);

    return message;
  }
}
